import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import "pages/accountConfiguration/AccountConfiguration.css";

import { setTitle } from "app/store/transmission/slice/transmissionSlice";

import AccountConfigurationTitle from "components/pages/accountPreferences/title/AccountConfigurationTitle";
import CustomTabs from "components/common/tabs/CustomTabs";
import useAccountConfiguration from "./useAccountConfiguration";

const AccountConfiguration = (props) => {
  const { tabs, currentTab, onTabChange } = useAccountConfiguration(props);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setTitle({ title: "Account Preferences" }));
  }, [dispatch]);

  return (
    <>
      <div className="preferences">
        <AccountConfigurationTitle />

        <CustomTabs
          tabs={tabs}
          selectedTab={currentTab}
          onChange={onTabChange}
        />
      </div>
    </>
  );
};

export default AccountConfiguration;
